import { Link } from "react-router-dom";
import "./styles.css";

export default function Verse() {
    return (
        <section className="invitation-closing">
            <div className="shared-gallery-cta">
                <h2 className="shared-gallery-title">GALERÍA COMPARTIDA</h2>
                <p className="shared-gallery-text">
                    Ayúdanos a guardar cada momento especial. Comparte las fotos que
                    tomes durante nuestra boda y disfruta los recuerdos de todos.
                </p>
                <Link to="/fotos" className="shared-gallery-button">
                    Ver y compartir fotos
                </Link>
            </div>

            <p className="verse">
                «Más valen dos que uno»<br />
                Eclesiastés 4:9
            </p>
        </section>
    );
};
